import React from 'react';
import MediaQuery from 'react-responsive/src/Component';
import PastEvents from 'components/organisms/pastEvents';
import PastEventsMobile from 'components/organisms/pastEventsMobile';

const ArtistDetailSection = props => {
  return (
    <div id={'artist-details'}>
      {props.data.artistsData.map((artistData, idx) => {
        let cms_overlay_data = {},
          show_cms_button = false;
        Object.values(props.data.cmsDetailsData).map(iterate_data => {
          if (iterate_data.artist_id === artistData.artistIntro.artist_id) {
            cms_overlay_data = iterate_data;
            show_cms_button = true;
          }
        });
        return (
          <>
            <MediaQuery maxDeviceWidth={575.6}>
              <PastEventsMobile
                pastEventsIntro={artistData.artistIntro}
                pastEvents={artistData.videos}
                data={props.data}
                type="artist"
                cmsDetailData={cms_overlay_data}
                showCmsButton={show_cms_button}
              />
            </MediaQuery>
            <MediaQuery minDeviceWidth={576}>
              <PastEvents
                pastEventsIntro={artistData.artistIntro}
                pastEvents={artistData.videos}
                cmsDetailData={cms_overlay_data}
                showCmsButton={show_cms_button}
              />
            </MediaQuery>
          </>
        );
      })}
    </div>
  );
};

export default ArtistDetailSection;
